import { defineStore } from 'pinia'
import { queryDataSets } from '@haohan/clw-api'
import { useProject } from '@haohan/clw-store'
import { LEFT_DATASET_TREE_TAB } from '../common/enum-constant'

export const useLayout = defineStore({
  id: 'layout',
  getters: {
    /**
     * 计算内容区宽度
     * @param state
     * @returns 内容区实际宽度
     */
    funWidth: (state) => {
      let funWidth = 108
      if (state.leftFunIsOpen) {
        funWidth = funWidth + 300
      }
      if (state.rightFunIsOpen) {
        funWidth = funWidth + 300
      }
      return funWidth
    }
  },
  state: () => {
    return {
      leftFunCurrentMenu: 'menu',
      leftFunIsOpen: true,
      rightFunCurrentMenu: 'component',
      rightFunIsOpen: true,
      rightContentIsOpen: true,
      // 数据集页面当前所处状态，提供给右侧侧边栏使用
      dataSourceViewStatus: 'view',
      currentDataSource: <DataSet>{},
      showLoginDialog: false,
      datasetView: 'TableDetail',
      datasetActiveNode: {},
      // 是否刷新数据集菜单树
      reloadDatasetTree: false,
      // 编辑页辅助线是否显示
      auxiliaryLineShow: false,
      // 辅助线位置
      auxiliaryLineTop: 0,
      // 表格列, 用于复制
      tableColumn4Copy: [],
      // 当前项目数据集集合
      dataSetList: [],
      dashboardFilter: 'all',
      showFirstDatasource: false, // 从菜单切换到数据集, 展示第一个数据集
      currentDatasetTreeTab: LEFT_DATASET_TREE_TAB.Dataset, // 数据集 | API 接口
      queryListCopy: [], // 复制的查询条件列表
      copyType: 'query' // 复制的类型 query:查询组件 | table 表格组件
    }
  },
  actions: {
    changeTableColumn4Copy(col: any[]) {
      this.tableColumn4Copy = col
    },
    changeLeftFunCurrentMenu(currentMenu: string): void {
      this.leftFunCurrentMenu = currentMenu
    },
    changeRightFunCurrentMenu(currentMenu: string): void {
      this.rightFunCurrentMenu = currentMenu
    },
    changeDataSourceViewStatus(status: string): void {
      this.dataSourceViewStatus = status
    },
    changeCurrentDataSource(currentDataSource: DataSet): void {
      this.currentDataSource = currentDataSource
    },
    setShowLoginDialog(showLoginDialog: boolean) {
      this.showLoginDialog = showLoginDialog
    },
    changeDatasetView(datasetView: string) {
      this.datasetView = datasetView
    },
    changeDatasetActiveNode(datasetActiveNode: any) {
      this.datasetActiveNode = datasetActiveNode
    },
    changeReloadDatasetTree(reloadDatasetTree: boolean) {
      this.reloadDatasetTree = reloadDatasetTree
    },
    // 重新加载项目时清空所有上个项目得缓存
    cleanBi() {
      this.datasetView = ''
      this.datasetActiveNode = {}
    },
    changeLeftFunIsOpen(isOpen: boolean) {
      this.leftFunIsOpen = isOpen
    },
    changeRightFunIsOpen(isOpen: boolean) {
      this.rightFunIsOpen = isOpen
    },
    changeRightContentIsOpen(isOpen: boolean) {
      this.rightContentIsOpen = isOpen
    },
    changeAuxiliaryLineShow(show: boolean) {
      this.auxiliaryLineShow = show
    },
    changeAuxiliaryLineTop(top: number) {
      this.auxiliaryLineTop = top
    },
    changeDataSetList(dataset: any) {
      this.dataSetList = dataset
    },
    // 加载数据集
    async loadDataSetList() {
      const projectStore = useProject()
      const res = await queryDataSets(projectStore.currentProject.id)
      this.dataSetList = res.data
    },
    changeDashboardFilter(filter: string) {
      this.dashboardFilter = filter
    },
    changeShowFirstDatasource(show: boolean) {
      this.showFirstDatasource = show
    },
    changeCurrentDatasetTreeTab(tab: LEFT_DATASET_TREE_TAB) {
      this.currentDatasetTreeTab = tab
    },
    changeQueryListCopy(list: any[]) {
      this.queryListCopy = list
    },
    changeCopyType(type: string) {
      this.copyType = type
    }
  }
})
